import enGb from './en-gb'
import bg from './bg'
import ru from './ru'

export const messages = {
  'en-gb': enGb,
  bg,
  ru,
}

export type MessageSchema = typeof enGb
